import { Box, Flex, Text } from '@chakra-ui/react';
import FaceliftCheckbox from '@/components/Atoms/FaceliftCheckbox/FaceliftCheckbox';
import FaceliftSwitch from '@/components/Atoms/FaceliftSwitch/FaceliftSwitch';
import type { NotificationItem } from './Notifications';

interface NotificationTypeProps {
	items: NotificationItem[];
	onSwitchChange: (itemIndex: number, value: boolean) => void;
	onMethodChange: (itemIndex: number, methodIndex: number, value: boolean) => void;
}

const moduleNameMap = {
	'Updation': 'Updates',
};

const NotificationType: React.FC<NotificationTypeProps> = ({
	items,
	onSwitchChange,
	onMethodChange,
}) => {
	return (
		<Box>
			<Text fontWeight="bold" fontSize={'sm'} mb={4}>
				Notifications Type
			</Text>
			<Flex wrap="wrap" gap={8}>
				<Flex align="start" flexDirection="column" gap={{ base: 6, md: 4 }}>
					{items.map((item, itemIndex) => (
						<Flex
							key={item.module}
							gap={{ base: 3, md: 10 }}
							flexDirection={{ base: 'column', md: 'row' }}
						>
							<Flex align="center" justifyContent="space-between" width="250px">
								<Text fontSize={'sm'}>{item.module}</Text>
								<FaceliftSwitch
									checked={item.enabled}
									onCheckedChange={(val) => onSwitchChange(itemIndex, val)}
								/>
							</Flex>
							{item.enabled && item.methods.length > 0 && (
								<Flex gap={{ base: 10, md: 20 }}>
									{item.methods.map((method, methodIndex) => (
										<FaceliftCheckbox
											key={`${item.module}-${method.name}`}
											checked={method.enabled}
											onCheckedChange={(checked: boolean) =>
												onMethodChange(itemIndex, methodIndex, !!checked)
											}
											label={moduleNameMap[method.name as keyof typeof moduleNameMap] || method.name}
											size="xs"
										/>
									))}
								</Flex>
							)}
						</Flex>
					))}
				</Flex>
			</Flex>
		</Box>
	);
};

export default NotificationType;
